"use strict";
'use client';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QuickViewDrawer = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../../../elements/button/Button");
var visuallyHiddenStyles = _interopRequireWildcard(require("../../../style/display/visually-hidden.module.scss"));
var _getProductUrl = _interopRequireDefault(require("../../../utils/product/getProductUrl"));
var styles = _interopRequireWildcard(require("./quick-view-drawer.module.scss"));
var _shouldShowQuickViewButton = require("./shouldShowQuickViewButton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var QuickViewDrawer = exports.QuickViewDrawer = function QuickViewDrawer(_ref) {
  var product = _ref.product,
    onClick = _ref.onClick,
    selectedSwatch = _ref.selectedSwatch,
    swatchOrder = _ref.swatchOrder,
    swatchOverride = _ref.swatchOverride,
    _ref$quickViewBundleL = _ref.quickViewBundleLoading,
    quickViewBundleLoading = _ref$quickViewBundleL === void 0 ? false : _ref$quickViewBundleL,
    className = _ref.className;
  var title = product.title,
    id = product.id;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var handleClick = function handleClick() {
    setLoading(true);
    return Promise.resolve(onClick(id, selectedSwatch.url || (0, _getProductUrl.default)(title, id, selectedSwatch), swatchOrder, swatchOverride === null || swatchOverride === void 0 ? void 0 : swatchOverride.color)).then(function () {
      setLoading(false);
    });
  };
  var showQuickView = (0, _shouldShowQuickViewButton.shouldShowQuickViewButton)(product);
  return showQuickView ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _classnames.default)(className, styles['qv-drawer']),
    "data-testid": "component-hover-drawer",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Button.SecondaryButton, {
      className: (0, _classnames.default)(styles['qv-drawer__button']),
      "data-testid": "component-quick-view-button",
      onClick: handleClick,
      size: "small",
      submitting: loading || quickViewBundleLoading,
      children: ["Quick view", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: visuallyHiddenStyles.visuallyHidden,
        children: ", ".concat(title)
      })]
    }, "quick-view")
  }) : null;
};